// @ts-nocheck
import React, { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Checkbox, TableListV2 } from 'sonata-react-components';

import { getSelectedCampaigns } from '@/store/selectors/reporting.selectors';
import { useReportDownloadSectionContext } from '../../ReportDownloadSection.context';
import { CampaignsSettingsStyled } from './CampaignsSettings.style';

import type { CampaignItem } from '@/ts-modules/reporting/Header/Campaigns/Multi/components/EditSelectionModal/EditSelectionModal';

type Props = {
  tabId: string;
};

function CampaignsSettings({ tabId }: Props) {
  const { formatMessage } = useIntl();
  const { getTabOptions, setCampaigns } = useReportDownloadSectionContext();

  const dataCampaigns = useSelector(getSelectedCampaigns);
  const campaignsIds = dataCampaigns.map(cp => cp.id);

  const tabOptions = getTabOptions(tabId);
  const noCampaignSelected = !tabOptions.campaigns.length;

  const [{ isCustomLines }, setState] = useState<{ isCustomLines: boolean }>({
    isCustomLines: tabOptions.isCustomSelectedCampaings
  });

  const columns = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name'
      }
    ],
    []
  );

  const defaultSelectedRows = useMemo(() => {
    return tabOptions.campaigns.reduce(
      (acc, cid) => ({
        ...acc,
        [cid]: true
      }),
      {}
    );
  }, []);

  const isMultiCampaign = dataCampaigns.length > 1;
  if (!isMultiCampaign) {
    return null;
  }

  const handleCheckboxClick = () => {
    setCampaigns(campaignsIds, tabId, !isCustomLines);
    setState(prevState => ({
      ...prevState,
      isCustomLines: !prevState.isCustomLines
    }));
  };

  const handleSelect = (campaings: CampaignItem[]) =>
    setCampaigns(
      campaings.map(campaing => campaing.id),
      tabId,
      isCustomLines
    );

  return (
    <CampaignsSettingsStyled className="campaignsSettings">
      <Checkbox
        active={isCustomLines}
        id="setReportLines-checkbox"
        isSwitch
        labelColor="#89A0C9"
        labelText={formatMessage({
          defaultMessage: 'Set lines',
          id: 'reporting.reportingDownload.campaignsFilterTitle'
        })}
        onClickAction={handleCheckboxClick}
        type="switch"
      />
      {isCustomLines && (
        <div className="campaignsSettings__selector">
          <TableListV2
            columns={columns}
            config={{
              globalFilter: {
                position: 'center',
                show: true
              },
              itemsSelectedConfig: {
                enable: true,
                label: formatMessage({
                  defaultMessage: 'Campaign lines selected',
                  id: 'reporting.campaignListSelector.counterLabel'
                })
              },
              maxHeight: 472,
              onChangeSelection: handleSelect,
              toolbar: {
                showSelectAll: true
              },
              type: 'list'
            }}
            data={dataCampaigns}
            defaultSelectedRows={defaultSelectedRows}
            id="campaignListSelector-editSelectionModal"
          />
        </div>
      )}
      {noCampaignSelected && (
        <span className="campaignsSettings__error">
          {formatMessage({
            defaultMessage: 'Please select at least one campaign',
            id: 'reporting.reportingDownload.errors.noCampaignSelected'
          })}
        </span>
      )}
    </CampaignsSettingsStyled>
  );
}

export default CampaignsSettings;
